exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputtype--toggle-container .toggle[disabled] .toggle-group label{cursor:not-allowed}", ""]);

// exports
